import { RouterModule } from '@angular/router';
import { VisitReservationComponent } from './visit-reservation.component';
import { FormsModule } from '@angular/forms';
import { PersonalVisitSearchComponent } from './component/visit-reservation-search/visit-reservation-search.component';
import { PersonalVisitDetailsDialogComponent } from './component/visit-reservation-details-dialog/visit-reservation-details-dialog.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {  ServiceResponseModule } from '@sdbn/common';
import { CommonLayoutModule, CommonUIModule } from '@sdbn/common';
import { TMCTableModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule as MatTabsModule } from '@angular/material/tabs';
import { MatTableModule as MatTableModule } from '@angular/material/table';

@NgModule({
  declarations: [
    VisitReservationComponent,
    PersonalVisitDetailsDialogComponent,
    PersonalVisitSearchComponent
  ],
  imports: [
    CommonModule,

    FormsModule,
    RouterModule,
    TMCTableModule,
    CommonLayoutModule,
    CommonTranslationModule,
    ServiceResponseModule,
    CommonUIModule,
    MatFormFieldModule,
    MatDialogModule,
    MatTabsModule,
    MatTableModule
  ],
  exports: [
    VisitReservationComponent
  ]
})
export class VisitReservationModule { }
